// durations are recorded in 10ths of a second by default
export function formatDuration(durationDs: number, base = 1000): string {
    const durationSecs = Math.floor(durationDs / base);
    const minutes = Math.floor(durationSecs / 60);
    const seconds = `${durationSecs - minutes * 60}`.padStart(2, '0');
    return `${minutes}:${seconds}`;
}

/**
 * A live "since" counter — `m:ss`, growing to `h:mm:ss` past an hour. Takes the clock as an argument
 * so a ticking `now` ref drives it and tests can pin it.
 */
export function formatElapsed(sinceMs: number, nowMs: number): string {
    const total = Math.max(0, Math.floor((nowMs - sinceMs) / 1000));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    const mmss = `${hours ? minutes.toString().padStart(2, '0') : minutes}:${seconds.toString().padStart(2, '0')}`;
    return hours ? `${hours}:${mmss}` : mmss;
}
